import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getMibList() {
    return axios.get(`${baseUrl}/mib/get-mib-list.do`);
  },
  getObjInfo(objId) {
    return axios.get(`${baseUrl}/mib/get-obj-info.do`, { params: { objId } });
  },
  insertMibFile(params) {
    return axios.post(`${baseUrl}/mib/insert-mib-file.do`, params);
  },
  deleteMibFiles(params) {
    return axios.post(`${baseUrl}/mib/delete-mib-files.do`, params);
  },
  updateMibFiles(params) {
    return axios.post(`${baseUrl}/mib/update-mib-files.do`, params);
  },
  getMibTreeRoot() {
    return axios.get(`${baseUrl}/mib/get-mib-tree-root.do`);
  },
  getMibTreeList(mibFileName) {
    return axios.get(`${baseUrl}/mib/get-mib-tree-list.do`, { params: { mibFileName } });
  },
  getMibTreeNode(params) {
    return axios.get(`${baseUrl}/mib/get-mib-tree-node.do`, { params });
  },
  getOidList(params) {
    return axios.post(`${baseUrl}/mib/get-oid-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/mib.js